import { jsonCopy } from '../../../utility/genericUtility';
import { datiIntermediarioInizializzato, datiConsensoInizializzato } from '../componentiBase/sezioniDichiarazioni';

export const datiIntermediario = jsonCopy(datiIntermediarioInizializzato);
export const datiConsenso = jsonCopy(datiConsensoInizializzato);